import { Messages } from '~src/codegen/Localize';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { LineageRelationshipType, RelatedContentType } from '~src/ts/models/ContentLineageRelationshipInfo';
import { GetContentLineageRelationshipsRequest } from '~src/ts/ServerApi/requests/GetContentLineageRelationshipsRequest';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

export class LinkedTasksResource {
  public getContentLineageRelationships(id: string, contentType: RelatedContentType, lineageRelationshipType: LineageRelationshipType) {
    return WebHttpClient.sendRequest(new GetContentLineageRelationshipsRequest({id: id, contentType: contentType, lineageRelationshipType: lineageRelationshipType}))
      .then((result) => {
        if(result.backfillRunning) {
          ToasterService.instance.pop({
            type: ToastType.Warning,
            text: Messages.linkedTaskLineageUnavailable(),
          });
        }
        return ServerApiMapper.contentLineageRelationships(result);
      });
  }
}

export const LinkedTasks = new LinkedTasksResource();
